import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import useGlobalModel from "@/erp_subpackage/model/globalModel";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useCustomerModel } from "../customerModel";


export function PageHeader() {
    const { t } = useTranslation();
    const { searchParam, organType, loadData, updateSearchParam, resetSearchParam } = useCustomerModel()
    const { getSelectedDictOne } = useDictModel();
    const { orgDs } = useGlobalModel(({ orgDs }) => [orgDs]);

    const searchFields = [
        ...(organType ? [{
            type: "Select",
            placeholder: t(`base.view.PageHeader.所属机构`),
            fieldName: "shopId",
            options: orgDs
        }] : []),
        {
            type: "Select",
            placeholder: t(`base.view.PageHeader.客户类型`),
            fieldName: "typeCode",
            options: getSelectedDictOne(DictCodeEnmu.CUSTOMER_TYPE),
        },
        {
            type: "Select",
            placeholder: t(`base.view.PageHeader.客户状态`),
            fieldName: "enable",
            options: [
                { label: t(`base.view.PageHeader.启用`), value: 1 },
                { label: t(`base.view.PageHeader.禁用`), value: 0 },
            ],
        },
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.客户编码`),
            fieldName: "code",
        },
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.客户名称`),
            fieldName: "customerName",
        },
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.联系人`),
            fieldName: "contact",
        },
    ]

    const searchMoreFields = [
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.联系电话`),
            fieldName: "phone",
        },
        {
            type: "Datepicker",
            placeholder: t(`base.view.PageHeader.登记日期`),
            fieldName: "createTime",
        },
    ]

    return (
        <YhPageHeader
            title= {t(`base.view.PageHeader.客户管理`)}
            size="small"
            triggerSearch={true}
            searchValues={searchParam}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData({ pageNum: 1 }, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    )
}
